export const DocumentDuplicateIcon = ({
  className,
}: {
  className?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
  >
    <path
      d="M5.60039 2.79961C5.60039 2.13687 6.13765 1.59961 6.80039 1.59961H9.90333C10.2216 1.59961 10.5268 1.72604 10.7519 1.95108L13.2489 4.44814C13.474 4.67318 13.6004 4.97841 13.6004 5.29667V9.99961C13.6004 10.6624 13.0631 11.1996 12.4004 11.1996H11.6004V8.49667C11.6004 7.86015 11.3475 7.2497 10.8974 6.79961L8.40039 4.30255C7.9503 3.85247 7.33985 3.59961 6.70333 3.59961H5.60039V2.79961Z"
      fill="currentColor"
    />
    <path
      d="M3.60039 4.79961C2.93765 4.79961 2.40039 5.33687 2.40039 5.99961V13.1996C2.40039 13.8624 2.93765 14.3996 3.60039 14.3996H9.20039C9.86313 14.3996 10.4004 13.8624 10.4004 13.1996V8.49667C10.4004 8.17841 10.274 7.87318 10.0489 7.64814L7.55186 5.15108C7.32682 4.92604 7.02159 4.79961 6.70333 4.79961H3.60039Z"
      fill="currentColor"
    />
  </svg>
);
